export default __webpack_public_path__ + "static/account-393fcc922f22b9aed64dfe94329952e5.jpg";